export default __webpack_public_path__ + "static/media/commercial1.d846aac3.PNG";